import React, { useEffect } from "react";
import { DropdownField } from "../../../../../../components/inputs";
import { Button, Flex, Form } from "antd";
import { useTranslation } from "react-i18next";
import {
  ErrorText,
  StyledForm,
  StyledModal,
} from "../../../../../../components/common/styles";
import { ReactComponent as ErrorIcon } from "../../../../../../assets/icons/Error.svg";

export const MoveDayAndWeekModal = (props: {
  modalOpen: boolean;
  setModalOpen: (value: boolean) => void;
  numberOfWeeks: number;
  timesPerWeek: number;
  handleModalOk: (day: number | null, week: number | null) => void;
  handleModalOverride: (day: number | null, week: number | null) => void;
  error?: string;
  setError: (value: string) => void;
}) => {
  const {
    modalOpen,
    setModalOpen,
    numberOfWeeks,
    timesPerWeek,
    handleModalOk,
    handleModalOverride,
    setError,
    error,
  } = props;
  const { t } = useTranslation();
  const [form] = Form.useForm();

  useEffect(() => {
    if (!modalOpen) {
      form.resetFields();
    }
  }, [modalOpen]);

  const daysOptions = Array.from(
    { length: timesPerWeek || 0 },
    (_, i) => i + 1
  ).map((_, index) => ({
    label: ` ${index + 1}`,
    value: index + "",
  }));

  const weeksOptions = Array.from(
    { length: numberOfWeeks || 0 },
    (_, i) => i + 1
  ).map((_, index) => ({
    label: `${t("Week")} ${index + 1}`,
    value: index + "",
  }));

  const onFinish = (values: any) => {
    if (values.day === null || values.week === null) {
      return;
    }
    handleModalOk(values.day, values.week);
  };

  return (
    <StyledModal
      title={t("Select week and day in the program")}
      open={modalOpen}
      onOk={() => {
        form.submit();
      }}
      onCancel={() => {
        setModalOpen(false);
      }}
      centered
      okText={t("Update")}
      cancelText={t("Cancel")}
      width={400}
      okButtonProps={{
        style: { color: "white" },
        disabled: !!error,
      }}
    >
      <StyledForm form={form} onFinish={onFinish} validateTrigger="onSubmit">
        <Flex gap={10} vertical>
          <Flex gap={20} style={{ marginTop: 20 }}>
            <DropdownField
              label={t("Week")}
              options={weeksOptions}
              isEditable={true}
              name="week"
              rules={[{ required: true, message: t("Required") }]}
              onChange={() => setError("")}
            />
            <DropdownField
              label={t("Day")}
              options={daysOptions}
              isEditable={true}
              name="day"
              rules={[{ required: true, message: t("Required") }]}
              onChange={() => setError("")}
            />
          </Flex>
          {error && (
            <Flex align="center" gap={5} justify="center">
              <ErrorIcon />
              <ErrorText>{error}</ErrorText>
            </Flex>
          )}
          {error && (
            <Flex vertical gap={10} style={{ marginTop: 10 }}>
              <b>{t("Would you like to overwrite the conflicting workout?")}</b>
              {t(
                "This action will deactivate the existing workout and schedule the current workout at the requested time"
              )}

              <Button
                onClick={() =>
                  handleModalOverride(
                    form.getFieldValue("day"),
                    form.getFieldValue("week")
                  )
                }
              >
                {t("Overwrite")}
              </Button>
            </Flex>
          )}
        </Flex>
      </StyledForm>
    </StyledModal>
  );
};
